import BaseApi from './BaseApi';

export const postSiteDailyWorkRecordApi = async (recordData) => {
  try {
    const response = await BaseApi.post('/site-daily-work-records', recordData);
    return response.data;
  } catch (error) {
    console.error('現場日次作業記録の作成に失敗しました:', error);
    throw error;
  }
};

export const getSiteDailyWorkRecordsApi = async (params) => {
  try {
    const response = await BaseApi.get('/site-daily-work-records', { params });
    return response.data;
  } catch (error) {
    console.error('現場日次作業記録の取得に失敗しました:', error);
    throw error;
  }
};

export const deleteSiteDailyWorkRecordApi = async (id) => {
  try {
    const response = await BaseApi.post('/site-daily-work-records/delete', { id });
    return response.data;
  } catch (error) {
    console.error('現場日次作業記録の削除に失敗しました:', error);
    throw error;
  }
};

export default {
  postSiteDailyWorkRecordApi,
  getSiteDailyWorkRecordsApi,
  deleteSiteDailyWorkRecordApi
};
